import { maxIntegerValue } from '~/components/common/form/commonValidations';

export const removeCommasDollars = (text: string) => {
  return text.replace(/[,$]/g, '');
};

export const LESS_THAN_ONE_MILLION = maxIntegerValue(1000000);
